export default {
  BRAND: 'brands',
  REPORT_ADMIN_REGIONAL: 'report-admin-regional',
  REPORT_DAILY: 'report-daily',
  REPORT_SHOPQR: 'report-shopqr',
  REPORT_APPROACH: 'report-approach',
  LIST_IMPLEMENT: 'list-implement-ticket',
  ASSIGN_IMPLEMENT: 'assign-implement',
  CREATE_IMPLEMENT_REQUEST: 'implementation-ticket',
  ALL_IMPLEMENT_TICKET: 'all-ticket-implementation',
  APPROVAL_TERMINAL: 'terminal-no-pay',
  JOBS_ADMIN: 'jobs-admin',
  PROGRESS_REPORT_EXPORT_EXCEL: 'report-progress-export-excel',
  PROGRESS_REPORT_EDIT_OPPORTUNITY_AMOUNT:
    'report-progress-edit-opportunity-amount',
  PROGRESS_REPORT_EDIT_FLAG: 'report-progress-edit-flag',
  PROGRESS_REPORT_VIEW: 'report-progress-view',
  TICKET_ISSUES: 'issues',
  TICKET_ISSUE_TYPES: 'issuetypes',
  TICKET_REPORT: 'reports',
  SHOP_TAKE_CARE: 'shop-take-care',
  SPOS: 'spos',
  HUMAN_RESOURCE_MANAGEMENT: 'human-resource-management',
  WAITING_GRANTED_BANK: 'view_wait_midtidbank_spos',
  TIMEKEEPING: 'timekeeping',
  FILE_IMPORT_LEAD: 'file_import',
  REPORT_SHOP_QR_SALE: 'report-shop-qr:sale',
  REPORT_SHOP_TAKE_CARE_SALE: 'report-shop-take-care:sale',
  REPORT_SPOS_SALE: 'report-spos:sale',
  CALL_CENTER_STAFF: 'callcenter_staff',
};
